import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage, defineMessages } from 'react-intl';

import { TokenName } from 'components/token/TokenName';

import { SectionTitle } from '../ui';
import type { TransactionsBid_tokenBid } from './__generated__/index.graphql';

const messages = defineMessages({
  detail: {
    id: 'TransactionsHistoryBid.detail',
    defaultMessage: 'Bid on',
  },
});

type Props = {
  tokenBid: TransactionsBid_tokenBid;
};

export const TransactionsBid = ({ tokenBid }: Props) => {
  return (
    <>
      <SectionTitle>
        <FormattedMessage {...messages.detail} />
      </SectionTitle>
      {tokenBid.auction.cards.map(nft => (
        <TokenName key={nft.slug} card={nft} withLink />
      ))}
    </>
  );
};

TransactionsBid.fragments = {
  tokenBid: gql`
    fragment TransactionsBid_tokenBid on TokenBid {
      id
      auction {
        id
        cards: anyCards {
          slug
          ...TokenName_anyCard
        }
      }
    }
    ${TokenName.fragments.anyCard}
  ` as TypedDocumentNode<TransactionsBid_tokenBid>,
};
